<ng-container *ngIf="vm$ | async as vm">
    <bs-reward-tokens-selector
        *ngIf="vm.isVisible"
        [selectedToken]="vm.selectedToken"
        [infoEnabled]="infoEnabled"
        [isTokenInvalid]="vm.isTokenInvalid"
        [hasAcquisitionOnboarding]="vm.hasAcquisitionOnboarding"
        (selectorClick)="onSelectorClick()"
        (infoClick)="onInfoClick()"></bs-reward-tokens-selector>
</ng-container>
